import { useState, useEffect, useCallback } from "react";
import { useSelector } from 'react-redux'
import axios from "axios";
// List products with Api
export default function  ListCourses (path,languaje, token)  {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [list, setList] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    // const user = useSelector( state => state.auth );
    const sendQuery = useCallback(async () => {
        let jwt = token;
        const url = process.env.REACT_APP_ADMIN_API_URL + "/"+ path;
        let data = "";
        let qs = require('qs');
        data = qs.stringify({
          'language_id': languaje
        });
        try {
            const res = await axios.post(
                url,
                data,
               {
                headers: {
                    'Authorization': 'Bearer '+jwt, 
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            setList(res.data);
            setLoading(false);
            setHasMore(false);
           
        } catch (err) {
          setError(err);
          sessionStorage.removeItem('userSelect');
          throw error;
        }
      }, [error, path]);
    
      useEffect(() => {
        sendQuery();
      }, [sendQuery]);
      return { loading, error, list, hasMore };
};